
type SubmitButtonProps = {
    classNames?: string,
    hasArrow?: boolean,
    saving?: boolean,
    buttonText: string
    disabled?: boolean,
    onClick?: any
}

const SubmitButton = (props: SubmitButtonProps) => {
    return (
        <button
            disabled={props.disabled ?? false}
            type="submit"
            onClick={props.onClick}
            className={
                'btn-blue ' +
                (props.classNames ? props.classNames : '') +
                (props.hasArrow ? ' btn-with-arrow' : '') +
                (props.saving ? ' saving' : '')
            }
        >
            {props.buttonText}
            <div className="spinner">
                <div className="cube1" />
                <div className="cube2" />
            </div>
        </button>
    );
};

export default SubmitButton;